<template>
  <BaseItem
      ref="LibraryFileItem"
      :item-uid="itemUid"
      parentComponent="LibraryFileTable"
      :lock-page="lockPage"
      :dto-detail-model="dto_detail_model"
      :dto-save-model="dto_save_model"
      :dto_validate_model="dto_validate_model"
      :store-name="store_name"
      :modal-dialog="modalDialog"
      :routeFullScreen="routeFullScreen"
      :height="height"
      :width="width"
  >
    <template v-slot:body="{editedItem, editedItemCommon, slotHeight}">
      <v-sheet v-if="editedItem !== null && editedItem !== undefined" class="px-3">
        <v-file-input
            v-model="file"
            :label="$t('columns.file')"
            counter
            show-size
            dense
            outlined
            clearable
            :disabled="lockPage(editedItem) || !!editedItem.direct_link"
            @change="onFileSelect(editedItem)"
        >
        </v-file-input>
        <v-text-field
            v-model="editedItem.direct_link"
            :label="$t('columns.direct_link')"
            dense
            outlined
            @change="onDirectLinkSet()"
            :disabled="lockPage(editedItem) || !!file"
        >
        </v-text-field>
        <v-checkbox
            v-model="editedItem.copy_to_store"
            :label="$t('columns.copy_to_store')"
            dense
            outlined
            @change="onDirectLinkSet()"
            :disabled="lockPage(editedItem) || !!file"
        >
        </v-checkbox>
      </v-sheet>
    </template>
  </BaseItem>
</template>

<script>
import ConfirmDialog from "@/components/Base/ConfirmDialog";
// import commonFunction from "@/commonFunction/commonFunction"
import BaseItem from "@/components/Base/BaseItem";
import {v4 as uuidv4} from "uuid";
import fileFunction from "@/commonFunction/fileFunction";


export default {
  name: 'LibraryFileItem',
  props: {
    itemUid: {default: null},
    dto_detail_model: {type: [String], default: 'LibraryFileDetailQueryDTO'},
    dto_save_model: {type: [String], default: 'LibraryFileSaveCommandDTO'},
    dto_validate_model: {type: [String], default: null},
    store_name: {type: [String], default: 'LibraryFileTable'},
    modalDialog: {type: [Boolean], default: false},
    routeFullScreen: {type: [Object], default: null},
    height: {default: null},
    width: {default: null},
  },

  components: {
    ConfirmDialog,
    BaseItem,
  },

  computed: {},

  methods: {
    onClose(event) {
      console.log('unload', event);
      if (this.$refs.LibraryFileItem.countBackup > 0) {
        // event.preventDefault()
        event.returnValue = 'Do you really want to leave? you have unsaved changes!'
        return event.returnValue
      }
      return true
    },
    validate() {
      console.log('file', this.file)
      if (!!this.editedItem)
        this.editedItem.property_state.error = !(!!this.file || !!this.editedItem.direct_link)
    },

    lockPage(editedItem) {
      return !(!!editedItem && !!editedItem.page_properties && !editedItem.page_properties.lock_page)
    },
    async onFileSelect(editedItem) {
      if (!!this.file)
        editedItem.file_base64 = await fileFunction.getBase64(this.file)
      else {
        editedItem.direct_link = null
        editedItem.copy_to_store = false
      }
      this.validate()
      console.log('editedItem.file_base64', editedItem.file_base64)
    },
    onDirectLinkSet() {
      console.log('onDirectLinkSet')
      if (!!this.editedItem && this.editedItem.direct_link === '') this.editedItem.direct_link = null
      if (!!this.editedItem && !this.editedItem.direct_link)
        this.file = null
      this.validate()
    },
  },

  async mounted() {
    window.addEventListener('beforeunload', this.onClose)
  }
  ,

  beforeRouteLeave(to, from, next) {
    console.log('beforeRouteLeave')
    if (this.$refs.LibraryFileItem.countBackup === 0)
      next()
    else {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer)
        next()
      else
        next(false)
    }
  },

  data() {
    return {
      file: null,
    }
  }
}
</script>

<style>
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n>
{
  "en": {
    "columns": {}
  },
  "de": {
    "columns": {}
  }
}
</i18n>
